import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-store-2-line text-background-50"></i>
              </div>
              <span className="text-lg font-heading text-foreground-900">洞洞杂货铺漫画</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              36漫画网旗下优质漫画阅读平台，提供海量漫画全集免费在线阅读。每日更新，畅享追漫乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-base font-heading text-foreground-900 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(1, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading text-foreground-900 mb-4">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/comic/dongdong-zahuopu" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">洞洞杂货铺</Link></li>
              <li><Link to="/comic/rexue-jianghu" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">热血江湖录</Link></li>
              <li><Link to="/comic/huakai-shengji" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">花开的声音</Link></li>
              <li><Link to="/comic/gaoxiao-richang" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">小明今天也很崩溃</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading text-foreground-900 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about#reputation" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">用户口碑</Link></li>
              <li><Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 36漫画网 洞洞杂货铺漫画 - 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站所有漫画均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}